module.exports = __webpack_public_path__ + "img/Ad-Banner-slide-3.ee74d16c.jpg";